import { createMultiStyleConfigHelpers, selectAnatomy } from "~/foundation/Chakra";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({

});

export const Select = defineMultiStyleConfig({ baseStyle })
